import * as FaIcons from "react-icons/fa";
import * as RiIcons from "react-icons/ri";
import * as GiIcons from "react-icons/gi";
import * as IoIcons from "react-icons/io";
import { translate } from "../utils/Common";
import { LuMail } from "react-icons/lu";
import { FaClock } from "react-icons/fa6";
import { FaCashRegister } from "react-icons/fa";
import { RiHomeOfficeFill } from "react-icons/ri"
import { GrConfigure } from "react-icons/gr";
import { BiSolidBank } from "react-icons/bi";

const optionsPages = {
  iconsClosed: {
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
  },
  actions: {
    read: {
       1: "view_cashbox_open_close",
       2: "view_cashbox_management",
       3: "view_remittances_new",
       4: "view_remittances_search",
       5: "view_remittances_deliver",
       6: "view_postoffice_management",
       7: "view_search_alerts",
       8: "view_postoffice_search",
       9: "view_cashbox_search",
       10: "view_admin_create_postoffice",
       11: "view_admin_create_user",
       12: "view_admin_postoffices", 
       13: "view_admin_users",
       14: "view_requests_management",
       15: 'view_deposits_new',
       16: 'view_cashbox_daily_report',
       17: 'view_cashbox_search_daily_report',
       18: 'view_postoffice_search_report'
    },
    create: {
       1: "create_remittances_new",
       2: "create_cashbox_daily_report",
     
    },
    update: {
       1: "update_cashbox_open_close",
       2: "update_cashbox_management",
       3: "update_remittances_deliver"
    },
    delete: {
  
    },
    search : {
      1: "search_remittances_search"
    }
  },
};

const pagesConfig = {
  1: {
    title: "Inicio",
    path: "/dashboard",
    icon: <FaIcons.FaHome size={18}/>,
  },
  2: {
    title: "Estatus",
    path: "/dashboard/cash/openclose",
  },
  3: {
    title: "Gestión",
    path: "/dashboard/cash/management",
    actions : []
  },
  4: {
    title: "Nuevo giro",
    path: "/dashboard/remittances/new",
  },
  5: {
    title: "Buscar",
    path: "/dashboard/remittances/search",
  },
  6: {
    title: "Entregar",
    path: "/dashboard/remittances/deliver",
    actions: [],
  },
  7: {
    title: "Busqueda",
    path: "/dashboard/accounting/search",
    },
  8: {
    title: "Solicitar reposicion de saldo",
    path: "/dashboard/accounting/reposition",
  },
  9: {
    title: "Reportes",
    path: "/dashboard/accounting/reports",
  },
  10: {
    title: "Consultar",
    path: "/dashboard/postoffice/consult",
  },
  11: {
    title: "Nueva solicitud efectivo",
    path: "/dashboard/postoffice/new",
  },
  12: {
    title: "Gestión de solicitud de efectivo",
    path: "/dashboard/postoffice/management"
    },
  13: {
    title: "Gestión",
    path: "/dashboard/postoffice/management",
  },
  14: {
    title: "Buscar",
    path: "/dashboard/alerts/search",
  },
  15: {
    title: "Buscar",
    path: "/dashboard/postoffice/search",
  },
  16: {
    title: "Buscar",
    path: "/dashboard/cash/search",
  },
  17: {
    title: "Crear Estafeta",
    path: "/dashboard/administration/create/postoffice",
  },
  18: {
    title: "Crear Usuario",
    path: "/dashboard/administration/create/user",
  },
  19: {
    title: "Estafetas",
    path: "/dashboard/administration/postoffices",
  },
  20: {
    title: "Usuarios",
    path: "/dashboard/administration/users",
  },
  21: {
    title: "Gestión",
    path: "/dashboard/requests/management",
  },
  22: {
    title: "Nuevo depósito",
    path: "/dashboard/deposits/new",
  },
  23: {
    title: "Crear informe",
    path: "/dashboard/cash/dailyReport",
  },
  24: {
    title: "Buscar informe",
    path: "/dashboard/cash/dailyReport/search"
  },
  25: {
    title: "Buscar reporte",
    path: "/dashboard/postoffice/report/search"
  }
};


const modulesPages = {
  1: {
    title: "Caja",
    path: "/dashboard/cash/",
    icon: <FaCashRegister size={16} />    ,
    iconClosed: <RiIcons.RiArrowDownSFill />,
    iconOpened: <RiIcons.RiArrowUpSFill />,
    ...optionsPages.iconsClosed,
    subNav: [],
  },
  2: {
    title: "Giros",
    path: "/dashboard/remittances/",
    icon: <GiIcons.GiReceiveMoney size={20} />,
    ...optionsPages.iconsClosed,
    subNav: [],
  },
  3: {
    title: "Contabilidad",
    path: "/dashboard/accounting",
    icon: <RiIcons.RiMoneyDollarCircleFill size={20} />    ,
    ...optionsPages.iconsClosed,
    subNav: [],
  },
  4: {
    title: "Estafeta",
    path: "/dashboard/postoffice/",
    icon: <RiHomeOfficeFill  size={18}/>,
    ...optionsPages.iconsClosed,
    isVisible: optionsPages.verifyCountry,
    subNav: [],
  },
  5: { 
    title: "Alertas",
    path: "/dashboard/alerts/",
    icon: <IoIcons.IoMdNotificationsOutline size={20} />,
    ...optionsPages.iconsClosed,
    subNav: [],
  },
  6: {
    title: "Administración",
    path: "/dashboard/admin/",
    icon: <GrConfigure size={16} />,
    ...optionsPages.iconsClosed,
    subNav: [],
  },
  7: {
    title: "Solicitudes",
    path: "/dashboard/requests/",
    icon: <FaClock size={16} />,
    ...optionsPages.iconsClosed,
    subNav: [],
  },
  8: {
    title: "Depósitos",
    path: "/dashboard/deposits/",
    icon: <BiSolidBank size={16} />,
    ...optionsPages.iconsClosed,
    subNav: [],
  },
};  

export const configRolesUsers = {
  0: {
    idRole: 1,
    name: "ADMIN",
    options: [
      pagesConfig[1], // Home
      {
        ...modulesPages[1], // Caja
        subNav: [
          pagesConfig[2],
        ]
      },
     {
      ...modulesPages[2], // Remesas
      subNav: [
        pagesConfig[4],
        pagesConfig[5],
        pagesConfig[6]
      ]
     },
    ]
  },
  1: {
    idRole: 1,
    name: "AGENTE",
    options: [
      pagesConfig[1], // Home
      {
        ...modulesPages[1], // Caja
        subNav: [
          {
            ...pagesConfig[2], //Abrir/cerrar caja
            actions: [
              optionsPages.actions.read[1],
            ] // Acciones permitidas
          },
          {
            ...pagesConfig[23], //Crear informe diario
            actions: [
              optionsPages.actions.read[16],
            ] // Acciones permitidas
          }
        ]
      },
     {
      ...modulesPages[2], // Remesas
      subNav: [
        {
          ...pagesConfig[4],//Crear remesas
          actions: [
            optionsPages.actions.read[3],
            optionsPages.actions.create[1]
          ] // Acciones permitidas
        },
        {
          ...pagesConfig[5], //Buscaar remesas
          actions: [
            optionsPages.actions.read[4],
          ] // Acciones permitidas
        },
        {
          ...pagesConfig[6], //Entregar remesas
          actions: [
            optionsPages.actions.read[5],
          ] // Acciones permitidas
        }
      ]
     },
    ]
  },

  2: {
    idRole: 2,
    name: "RECAUDADOR",
    options: [
      pagesConfig[1], // Home
      {
        ...modulesPages[1], // Caja
        subNav: [
          {
            ...pagesConfig[3], //Gestión de caja
            actions: [
              optionsPages.actions.read[2],
            ] // Acciones permitidas
          },
          {
            ...pagesConfig[16], //Gestión de caja
            actions: [
              optionsPages.actions.read[9],
            ] // Acciones permitidas
          },
                    {
            ...pagesConfig[24], //Buscar informe diario
            actions: [
              optionsPages.actions.read[17],
            ] // Acciones permitidas
          }
        ]
      },
      {
        ...modulesPages[4],
        subNav:[
          {
            ...pagesConfig[13], //Gestión de Estafeta
            actions: [
              optionsPages.actions.read[6],
            ] // Acciones permitidas
          },
          {
            ...pagesConfig[15], //Busqueda de Estafeta
            actions: [
              optionsPages.actions.read[8],
            ] // Acciones permitidas
          },
          {
            ...pagesConfig[25], //Buscar informe de comisiones
            actions: [
              optionsPages.actions.read[18],
            ] // Acciones permitidas
          }
        ]
      },
      {
        ...modulesPages[5],
        subNav:[
          {
            ...pagesConfig[14], //Busqueda de alertas
            actions: [
              optionsPages.actions.read[7],
            ] // Acciones permitidas
          }
        ]
      }
    ]
  },

  3: {
    idRole: 3,
    name: "SUPERVISOR",
    options: [
      pagesConfig[1], // Home
      {
        ...modulesPages[1], // Caja
        subNav: [
          {
            ...pagesConfig[3], //Gestión de caja
            actions: [
              optionsPages.actions.read[2],
            ] // Acciones permitidas
          },
          {
            ...pagesConfig[16], //Gestión de caja
            actions: [
              optionsPages.actions.read[9],
            ] // Acciones permitidas
            },
                    {
            ...pagesConfig[23], //Crear informe diario
            actions: [
              optionsPages.actions.read[16],
            ] // Acciones permitidas
           },
            {
            ...pagesConfig[24], //Buscar informe diario
            actions: [
              optionsPages.actions.read[17],
            ] // Acciones permitidas
          }
        ]
      },
     {
      ...modulesPages[2], // Remesas
      subNav: [
        {
          ...pagesConfig[4],//Crear remesas
          actions: [
            optionsPages.actions.read[3],
          ] // Acciones permitidas
        },
        {
          ...pagesConfig[5], //Buscaar remesas
          actions: [
            optionsPages.actions.read[4],
          ] // Acciones permitidas
        },
        {
          ...pagesConfig[6], //Entregar remesas
          actions: [
            optionsPages.actions.read[5],
          ] // Acciones permitidas
        }
      ]
     },
     {
      ...modulesPages[4],
      subNav:[
        {
          ...pagesConfig[13], //Gestión de Estafeta
          actions: [
            optionsPages.actions.read[6],
          ] // Acciones permitidas
        },
        {
          ...pagesConfig[15], //Busqueda de Estafeta
          actions: [
            optionsPages.actions.read[8],
          ] // Acciones permitidas
        },
        {
          ...pagesConfig[25], //Buscar informe de comisiones
          actions: [
            optionsPages.actions.read[18],
          ] // Acciones permitidas
        }
      ]
    },
    {
      ...modulesPages[5],
      subNav:[
        {
          ...pagesConfig[14], //Busqueda de alertas
          actions: [
            optionsPages.actions.read[7],
          ] // Acciones permitidas
        }
      ]
    },
    {
      ...modulesPages[7], // Solicitudes
      subNav: [
        {
          ...pagesConfig[21], // Solicitudes
          actions: [
            optionsPages.actions.read[14],
          ] // Acciones permitidas
        }
      ]
    },
    ]
  },

  4: {
    idRole: 4,
    name: "RECAUDADOR PROVINCIAL",
    options: [
      pagesConfig[1], // Home
      {
        ...modulesPages[1], // Caja
        subNav: [
          {
            ...pagesConfig[16], //Busqueda de caja
            actions: [
              optionsPages.actions.read[9],
            ] // Acciones permitidas
          }
        ]
      },
      {
        ...modulesPages[4],
        subNav:[
         {
          ...pagesConfig[13], //Gestión de Estafeta
          actions: [
            optionsPages.actions.read[6],
          ] // Acciones permitidas
         },
          {
            ...pagesConfig[15], //Busqueda de Estafeta
            actions: [
              optionsPages.actions.read[8],
            ] // Acciones permitidas
          },
          {
            ...pagesConfig[25], //Buscar informe de comisiones
            actions: [
              optionsPages.actions.read[18],
            ] // Acciones permitidas
          }
        ]
      },
          {
      ...modulesPages[8], // Depositos
      subNav: [
        {
          ...pagesConfig[22], // Depositos
          actions: [
            optionsPages.actions.read[15],
          ] // Acciones permitidas
        }
      ]
    },
    ]
  },

  5: {
    idRole: 5,
    name: "CONTADOR PROVINCIAL",
    options: [
      pagesConfig[1], // Home
      {
        ...modulesPages[1], // Caja
        subNav: [
          {
            ...pagesConfig[16], //Busqueda de caja
            actions: [
              optionsPages.actions.read[9],
            ] // Acciones permitidas
          }
        ]
      },
      {
        ...modulesPages[4],
        subNav:[
          {
            ...pagesConfig[15], //Busqueda de Estafeta
            actions: [
              optionsPages.actions.read[8],
            ] // Acciones permitidas
          },
          {
            ...pagesConfig[25], //Buscar informe de comisiones
            actions: [
              optionsPages.actions.read[18],
            ] // Acciones permitidas
          }
        ]
      },
      {
        ...modulesPages[7], // Solicitudes
        subNav: [
          {
            ...pagesConfig[21], // Solicitudes
            actions: [
              optionsPages.actions.read[14],
            ] // Acciones permitidas
          }
        ]
      }
    ]
  },

  6: {
      idRole: 6,
      name: "ADMINISTRADOR PROVINCIAL",
      options: [
        pagesConfig[1], // Home
        {
          ...modulesPages[1], // Caja
          subNav: [
            {
              ...pagesConfig[16], //Busqueda de caja
              actions: [
                optionsPages.actions.read[9],
              ] // Acciones permitidas
            }
          ]
        },
        {
          ...modulesPages[2], // Remesas
          subNav: [
            {
              ...pagesConfig[5], //Buscar remesas
              actions: [
                optionsPages.actions.read[4],
              ] // Acciones permitidas
            }
          ]
        },
        {
          ...modulesPages[4], // Estafeta
          subNav: [
            {
              ...pagesConfig[15], //Busqueda de Estafeta
              actions: [
                optionsPages.actions.read[8],
              ] // Acciones permitidas
            },
            {
              ...pagesConfig[25], //Buscar informe de comisiones
              actions: [
                optionsPages.actions.read[18],
              ] // Acciones permitidas
            }
          ]
        },
        {
          ...modulesPages[5], // Alertas
          subNav: [
            {
              ...pagesConfig[14], //Busqueda de alertas
              actions: [
                optionsPages.actions.read[7],
              ] // Acciones permitidas
            }
          ]
        }
      ]
  },

  7: {
      idRole: 7,
      name: "CONSULTA",
      options: [
        pagesConfig[1], // Home
        {
          ...modulesPages[1], // Caja
          subNav: [
            {
              ...pagesConfig[16], //Busqueda de caja
              actions: [
                optionsPages.actions.read[9],
              ] // Acciones permitidas
            }
          ]
        },
        {
          ...modulesPages[2], // Remesas
          subNav: [
            {
              ...pagesConfig[5], //Buscar remesas
              actions: [
                optionsPages.actions.read[4],
              ] // Acciones permitidas
            }
          ]
        },
        {
          ...modulesPages[4], // Estafeta
          subNav: [
            {
              ...pagesConfig[15], //Busqueda de Estafeta
              actions: [
                optionsPages.actions.read[8],
              ] // Acciones permitidas
            },
            {
              ...pagesConfig[25], //Buscar informe de comisiones
              actions: [
                optionsPages.actions.read[18],
              ] // Acciones permitidas
            }
          ]
        },
        {
          ...modulesPages[5], // Alertas
          subNav: [
            {
              ...pagesConfig[14], //Busqueda de alertas
              actions: [
                optionsPages.actions.read[7],
              ] // Acciones permitidas
            }
          ]
        }
      ]
  },

  8: {
      idRole: 8,
      name: "SOPORTE TÉCNICO",
      options: [
        pagesConfig[1], // Home
        {
          ...modulesPages[6], // Administración
          subNav:[
            {
              ...pagesConfig[19], // Ver estafetas
              actions: [
                optionsPages.actions.read[12],
                optionsPages.actions.read[10],
              ] // Acciones permitidas
            },
            {
              ...pagesConfig[20], // Ver clientes
              actions: [
                optionsPages.actions.read[11],
                optionsPages.actions.read[13],
              ] // Acciones permitidas
            }
          ]
        },
      ]
  },

  9: {
      idRole: 9,
      name: "SUPER ADMIN",
      options: [
        pagesConfig[1], // Home
        {
          ...modulesPages[1], // Caja
          subNav: [
            {
              ...pagesConfig[3], //Gestión de caja
              actions: [
                optionsPages.actions.read[2],
              ] // Acciones permitidas
            },
            {
              ...pagesConfig[16], //Gestión de caja
              actions: [
                optionsPages.actions.read[9],
              ] // Acciones permitidas
            },
            {
            ...pagesConfig[24], //Buscar informe diario
            actions: [
              optionsPages.actions.read[17],
            ] // Acciones permitidas
          }
          ]
        },
      {
        ...modulesPages[2], // Remesas
        subNav: [
          {
            ...pagesConfig[5], //Buscaar remesas
            actions: [
              optionsPages.actions.read[4],
            ] // Acciones permitidas
          }
        ]
      },
      {
        ...modulesPages[4],
        subNav:[
          {
            ...pagesConfig[13], //Gestión de Estafeta
            actions: [
              optionsPages.actions.read[6],
            ] // Acciones permitidas
          },
          {
            ...pagesConfig[15], //Busqueda de Estafeta
            actions: [
              optionsPages.actions.read[8],
            ] // Acciones permitidas
          },
          {
            ...pagesConfig[25], //Buscar informe de comisiones
            actions: [
              optionsPages.actions.read[18],
            ] // Acciones permitidas
          }
        ]
      },
      {
        ...modulesPages[5],
        subNav:[
          {
            ...pagesConfig[14], //Busqueda de alertas
            actions: [
              optionsPages.actions.read[7],
            ] // Acciones permitidas
          }
        ]
      },
      {
        ...modulesPages[7], // Solicitudes
        subNav: [
          {
            ...pagesConfig[21], // Solicitudes
            actions: [
              optionsPages.actions.read[14],
            ] // Acciones permitidas
          }
        ]
      },
      {
        ...modulesPages[6], // Administración
        subNav:[
          {
            ...pagesConfig[19], // Ver estafetas
            actions: [
              optionsPages.actions.read[12],
              optionsPages.actions.read[10],
            ] // Acciones permitidas
          },
          {
            ...pagesConfig[20], // Ver clientes
            actions: [
              optionsPages.actions.read[11],
              optionsPages.actions.read[13],
            ] // Acciones permitidas
          }
        ]
      },
      ]
  },
};

export const verifyAccessViewPermissions = (permissionNames) => {
  // Obtener el rol del usuario almacenado en sessionStorage
  const userRole = JSON.parse(sessionStorage.getItem("user")).roleId;

  const roleConfig = configRolesUsers[userRole];

  for (const permissionName of permissionNames) {
    let hasPermission = false;
    
    for (const option of roleConfig.options) {
     
      if (option.subNav) {
        for (const subPage of option.subNav) {
          if (subPage.actions && subPage.actions.includes(permissionName)) {
            hasPermission = true;
            break; 
          }
        }
      } else if (option.actions && option.actions.includes(permissionName)) {
        hasPermission = true;
        break; 
      }
    }

    if (!hasPermission) {
      return false;
    }
  }
  
  return true;
};